import { render, staticRenderFns } from "./OrderEdit.vue?vue&type=template&id=018fe049&"
import script from "./OrderEdit.vue?vue&type=script&lang=js&"
export * from "./OrderEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports